<template>
  <div class="course-intro-page">
    <el-button type="primary" size="mini" class="add-button" @click="handleAdd"
      >增加</el-button
    >
    <el-tabs
      v-model="activeName"
      type="border-card"
      closable
      @tab-remove="handleDel"
    >
      <el-tab-pane
        v-for="(item, idx) in editableTabs"
        :key="idx"
        :label="item.remark"
        :name="String(idx)"
      >
        <el-form label-width="100px">
          <el-form-item label="标题">
            <el-input v-model="item.remark"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <wedit v-model="item.paramValue"></wedit>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="publish" :loading="loading"
              >发布</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import wedit from "@/components/wedit/index.vue";
import { makeSgin } from "@/utils/index";
import { DeleteConfig } from "@/api/site";

export default {
  data() {
    return {
      activeName: "0",
      name: "",
      loading: false,
      editableTabs: [],
    };
  },
  components: {
    wedit,
  },
  created() {
    this.getList();
  },
  mounted() {
    //
  },
  methods: {
    async handleDel(name) {
      console.log("name", name);
      const num = Number(name);
      if (Number(name) <= 0) {
        this.activeName = "0";
      }
      const obj = this.editableTabs[num];
      console.log(obj);
      if (obj.id) {
        try {
          const { data } = await DeleteConfig(obj.id);
          if (data.code === 0) {
            this.$message.success("删除成功");
            this.activeName = String(num - 1);
            this.editableTabs.splice(num, 1);
          } else {
            this.$message.error("删除失败");
          }
        } catch (error) {
          console.log(error);
          this.$message.error("删除失败");
        }
      } else {
        this.activeName = String(num - 1);
        this.editableTabs.splice(num, 1);
      }
    },
    handleAdd() {
      this.editableTabs.push({
        remark: "公司简介",
        paramValue: "",
      });
      this.activeName = String(this.editableTabs.length - 1);
    },
    publish() {
      this.loading = true;
      const target = this.editableTabs[this.activeName];
      if (target.id) {
        // 编辑
        this.$http({
          url: this.$http.adornUrl("sys/config/update"),
          method: "put",
          data: this.$http.adornData({
            paramKey: "ABOUT_US",
            paramValue: target.paramValue,
            id: target.id,
            remark: target.remark,
          }),
        })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message({
                message: "发布成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error(data.msg);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        // 新增
        this.$http({
          url: this.$http.adornUrl("sys/config/save"),
          method: "post",
          data: this.$http.adornData({
            paramKey: "ABOUT_US",
            paramValue: target.paramValue,
            remark: target.remark,
          }),
        })
          .then(({ data }) => {
            // console.log(res)
            if (data.code === 0) {
              this.$message({
                message: "发布成功",
                type: "success",
                duration: 1500,
              });
              this.getList();
            } else {
              this.$message.error(data.msg);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getList() {
      this.$http({
        url: this.$http.adornUrl("open/api/aboutUs?sign=" + makeSgin()),
        method: "get",
      }).then(({ data }) => {
        if (data.code === 0) {
          this.editableTabs = data.data;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.course-intro-page {
  position: relative;
  .add-button {
    position: absolute;
    right: 10px;
    top: 6px;
    z-index: 9;
  }
}
</style>
